import dayjs, { type Dayjs } from 'dayjs';
import 'dayjs/locale/zh-cn';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);
dayjs.locale('zh-cn');

export const formatTime = ({
    time = dayjs(),
    format = 'YYYY-MM-DD',
}: {
    time?: string | number | Date | Dayjs;
    format?: string | boolean;
}) => {
    const datetime = dayjs(time).locale('zh-cn');
    return typeof format === 'string' ? datetime.format(format) : datetime;
};

export const calculateDayDiff = (startTime: dayjs.ConfigType, endTime: dayjs.ConfigType) => dayjs(startTime).diff(dayjs(endTime), 'day');

export { dayjs };

// 将秒数转换为 ${xx}h${xx}m${xx}s 格式
export const formatDuration = (seconds: string | number): string => {
    const totalSeconds = typeof seconds === 'string' ? parseInt(seconds, 10) : seconds;
    if (isNaN(totalSeconds) || totalSeconds < 0) return '0s';

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    const parts: string[] = [];

    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);

    return parts.join('');
};
